import {analyticsLogEvent} from '../api'

interface EventVideoParameters {
    eventName: 'video'
    action: string
    category: 'video'
    label?: string
}

/**
 * @name analyticsEventVideo
 *
 * @event
 *
 * @description
 * Tracks a custom event triggered by the user.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {EventCustomCategory} params.category - Category of the event.
 * @param {EventCustomAction} params.action - Action of the event.
 * @param {EventCustomLabel | undefined} [params.label] - Label of the event (optional).
 */
export function analyticsEventVideo({eventName, action, category, label}: EventVideoParameters) {
    const eventDetails = {
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
    }

    // Clean undefined values from the event details object
    Object.keys(eventDetails).forEach((key) => {
        if (eventDetails[key] === undefined) {
            delete eventDetails[key]
        }
    })

    analyticsLogEvent(eventName, eventDetails)
}
